__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-03-17-1773748594-stable-dev/";